import { LoaderFunctionArgs, MetaFunction } from "@remix-run/cloudflare";
import { useLoaderData } from "@remix-run/react";
import { useTranslation } from "react-i18next";
import WpContent from "~/components/common/WpContent";
import { getLocale } from "~/lib/i18n.server";
import { getMetaData } from "~/lib/utils";

export const meta: MetaFunction = (data: any) => {
  const { t } = useTranslation();
  return getMetaData(data, {
    title: t("Termini e condizioni"),
    description: t(
      "I nostri Termini e condizioni sono stati redatti per garantire la massima trasparenza e protezione per tutti i nostri clienti."
    ),
  });
};

export async function loader({ context, request }: LoaderFunctionArgs) {
  try {
    const pageSlug = "termini-e-condizioni";

    const locale = await getLocale(request);
    const lang = locale;
    const res = await fetch(
      `${context.cloudflare.env.WP_API_HOST}/wp-json/wp/v2/pages?slug=${pageSlug}&lang=${lang}`
    );
    const pages: any = await res.json();
    if (!res.ok) {
      throw new Error(`Failed to fetch: ${res.statusText}`);
    }
    if (pages && pages.length > 0) {
      return {
        page: pages[0],
        seo: pages[0]?.yoast_head_json,
        lang,
        turnstileSiteKey: context.cloudflare.env.TURNSTILE_SITE_KEY ?? "",
      };
    } else {
      return {
        error: "No pages found for the given slug.",
        page: {},
        turnstileSiteKey: context.cloudflare.env.TURNSTILE_SITE_KEY ?? "",
      };
    }
  } catch (err) {
    return {
      err: err,
      page: {},
      turnstileSiteKey: context.cloudflare.env.TURNSTILE_SITE_KEY ?? "",
    };
  }
}

export default function TermsAndConditions() {
  const loaderData = useLoaderData<typeof loader>();

  return (
    <div
      className={`
        relative terms-and-conditions-page
      `}
    >
      <main className="flex flex-col container mx-auto pt-12 px-4">
        <h1 className="text-2xl lg:text-5xl text-secondary font-tenor-sans">
          {loaderData.page.title?.rendered}
        </h1>
        {loaderData.page && loaderData.page.content?.rendered && (
          <section className="w-full py-12 grid grid-cols-1 gap-8">
            <WpContent
              className="mt-2"
              html={loaderData.page.content.rendered}
              turnstileSiteKey={loaderData.turnstileSiteKey}
            />
          </section>
        )}
      </main>
    </div>
  );
}
